import React from "react";
import styles from './index.module.scss';
import { fileDownloadByPath } from "@src/services/FileDownload";

import { ForensicsModalTable } from '../ForensicsModalTable';

//导入antd
import { Table, Modal,Button, Empty } from 'antd';

export const ForensicsModal = (props: any) => {
    const { forensicsModal, setForensicsModal, evidenceList, loading, claimsNo } = props;

    //表格数据，空数组
    const openDataSouce: any = [];  //开立的数据
    const circulationDataSouce: any = [];   //流转的数据 
    const financingDataSouce: any = []; //融资的数据 
    const clearingDataSouce: any = [];  //清分的数据
    let openTxId: string = '';  //开立的txId
    let circulationTxId: string = '';   //流转的txId
    let financingTxId: string = ''; //融资的txId
    let clearingTxId: string = '';  //清分的txId

    //下载文件
    const downloadFile: any = (filePath:string) => {
        fileDownloadByPath({
            filePath: filePath,
        }).then((res: any) => {
            //下载文件     
            const nav: any = window.navigator;
            //处理IE
            if (nav.msSaveBlob) {
                const blob = new Blob([res], { type: 'application/octet-stream' });
                const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
                nav.msSaveBlob(blob, fileName);
            }else{
                const blob = new Blob([res], { type: 'application/octet-stream' });
                const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
                const elink = document.createElement('a');
                elink.download = fileName;
                elink.style.display = 'none';
                elink.href = URL.createObjectURL(blob);
                document.body.appendChild(elink);
                elink.click();
                URL.revokeObjectURL(elink.href); // 释放URL 对象
                document.body.removeChild(elink);
            }
        })
    }

    //添加数据方法
    const addData = (data: any, dataSource: any) => {
        data.forEach((item: any, index: number) => {
            dataSource.push({
                key: index + 1,
                name: item.fileName,
                Hash: item.fileHash,
                action:
                    <div className={styles.forensics_modal_table_action}>
                        <Button type="primary" onClick={() => downloadFile(item.filePath)}>
                            <img src={require('@src/assets/imgs/forensics/download.png').default} className={styles.forensics_modal_table_action_icon} alt="" />
                            <span>
                                下载
                            </span>
                        </Button>
                    </div>
            })
        })
    }

    //遍历数据包里面的数据列表
    evidenceList.forEach((item: any, index: number) => {
        //根据businessType判断是哪个表格
        if(item.businessType === '1'){
            addData(item.fileDetailList, openDataSouce)
            openTxId = item.txId
        }else if(item.businessType === '2'){
            addData(item.fileDetailList, circulationDataSouce)
            circulationTxId = item.txId
        }else if(item.businessType === '3'){
            addData(item.fileDetailList, financingDataSouce)
            financingTxId = item.txId
        }else if(item.businessType === '4'){
            addData(item.fileDetailList, clearingDataSouce)
            clearingTxId = item.txId
        }
    })

    // 如果数据为空，则返回空的模态框，否则返回有数据的模态框
    if(openDataSouce.length === 0 && circulationDataSouce.length === 0 && financingDataSouce.length === 0 && clearingDataSouce.length === 0){
        return (
            <Modal
                open={forensicsModal}
                footer={null}
                onCancel={() => setForensicsModal(false)}
                className={styles.forensics_modal_box}
                width={1000}
                centered={true}
                title={
                    <div className={styles.forensics_modal_title_box}>
                        <div className={styles.forensics_modal_title}>证据包详情</div>
                    </div>
                }
            >
                <div className={styles.forensics_modal}>
                    <div className={styles.forensics_modal_title}>证据包名称：{claimsNo}</div>
                    <div className={styles.forensics_modal_content}>
                        <Empty className={styles.forensics_modal_content_empty} />
                        <div className={styles.forensics_modal_content_bottom}>
                            
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }else{
        return (
            <Modal
                open={forensicsModal}
                footer={null}
                onCancel={() => setForensicsModal(false)}
                className={styles.forensics_modal_box}
                width={1225}
                title={
                    <div className={styles.forensics_modal_title_box}>
                        <div className={styles.forensics_modal_title}>证据包详情</div>
                    </div>
                }
            >
                <div className={styles.forensics_modal}>
                    <div className={styles.forensics_modal_title}>证据包名称：{claimsNo}</div>
                    <div className={styles.forensics_modal_content}>
                        <div>
                            <ForensicsModalTable tableDataSource={openDataSouce} tableTitle="开立" txId={openTxId} loading={loading} />
                            <ForensicsModalTable tableDataSource={circulationDataSouce} tableTitle="流转" txId={circulationTxId} loading={loading} />
                            <ForensicsModalTable tableDataSource={financingDataSouce} tableTitle="融资" txId={financingTxId} loading={loading} />
                            <ForensicsModalTable tableDataSource={clearingDataSouce} tableTitle="清分" txId={clearingTxId} loading={loading} />
                        </div>
                    </div>
                </div>
            </Modal>
        )
            }
}
